import { VdsButton } from '@volt/volt-extended-components-react';
import styles from './Notes.module.scss';
import Note from '../note/Note';
import { NoteModel } from '@customer/store/apis/commonModels';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@customer/store/hooks';
import { NoResults } from '@dmc/ui';
import { useCallback } from 'react';
import NoteSkeleton from '../note-skeleton/NoteSkeleton';
import { CollectionModel } from '@customer/store/api';

export interface NotesProps {
  countTrans: string;
  noneTrans: string;
  entityId?: string;
  notes?: CollectionModel<NoteModel>;
  hideAdd?: boolean;
  onAdd?: () => void;
}

export const Notes = ({
  entityId,
  countTrans,
  noneTrans,
  notes,
  hideAdd = false,
  onAdd,
}: NotesProps) => {
  const { t } = useTranslation();

  const siteId = useAppSelector(state => state.auth.siteId);
  const darkTheme = useAppSelector(state => state.prefs.darkTheme);

  const onShowAddNoteForm = useCallback(() => {
    if (onAdd) {
      onAdd();
    }
  }, [onAdd]);

  const isLoading = typeof notes === 'undefined';
  const notesCount = notes?.items.length ?? 0;

  return (
    <article className={styles.container}>
      {!hideAdd && (
        <header className={styles.header}>
          <div className={styles.header__title}>{t(countTrans, { count: notesCount })}</div>
          <div className={styles.header__actions}>
            <VdsButton
              variant="secondary"
              size="medium"
              onClick={onShowAddNoteForm}
              disabled={typeof entityId === 'undefined' || typeof siteId === 'undefined'}
            >
              {t('AddNote')}
            </VdsButton>
          </div>
        </header>
      )}

      {isLoading ? (
        <div className={styles.notes}>
          {[...Array(3).keys()].map(key => (
            <NoteSkeleton key={key} />
          ))}
        </div>
      ) : notesCount ? (
        <div className={styles.notes}>
          {notes?.items.map((note: NoteModel) => {
            return <Note key={note.id} {...note} />;
          })}
        </div>
      ) : (
        <NoResults
          description={t(noneTrans)}
          background={darkTheme ? 'var(--surface-low)' : undefined}
        />
      )}
    </article>
  );
};

export default Notes;
